/* eslint-disable angular/controller-as */
angular.
module("digiexam").
controller("DxVerificationController", function VerificationController(
	$scope,
	$routeParams,
	user,
	faults,
	DX_URLS,
	dxLocalize
) {
	"use strict";
	var userId = parseInt($routeParams.userId, 10);
	var code = $routeParams.code;

	$scope.Urls = DX_URLS;
	$scope.state = "verify";
	$scope.errorMessage = "";

	function success(response) {
		if (response.faults) {
			$scope.state = "error";
			if (response.faults.indexOf(faults.WRONG_VERIFICATION_CODE) >= 0) {
				$scope.errorMessage = dxLocalize.get("VerificationError_WrongCode");
			} else {
				$scope.errorMessage = dxLocalize.get("UnknownError");
			}
		} else {
			$scope.state = "finished";
		}
	}

	function error() {
		$scope.state = "error";
		$scope.errorMessage = dxLocalize.get("UnknownError");
	}

	user.verify(userId, code).then(success, error);

	$scope.isState = function isState(state) {
		return $scope.state === state;
	};
});
